/**
 * Alert sound service - plays sound and vibration when dose threshold exceeded
 * Uses react-native-sound-player and React Native Vibration API
 *
 * Add alert.mp3 to android/app/src/main/res/raw/ and iOS bundle for local playback.
 * Falls back to playUrl with a simple tone URL if local file missing.
 */

import { Platform, Vibration } from 'react-native';
import SoundPlayer from 'react-native-sound-player';

const FALLBACK_ALERT_URL =
  'https://assets.mixkit.co/active_storage/sfx/2869-2869.wav';

let lastAlertTime = 0;
const ALERT_COOLDOWN_MS = 5000;

/** Vibration pattern: 200ms vibrate, 100ms pause, 200ms vibrate (alert pattern) */
const ALERT_VIBRATION_PATTERN = [0, 200, 100, 200];

export async function playAlertSound(): Promise<void> {
  const now = Date.now();
  if (now - lastAlertTime < ALERT_COOLDOWN_MS) return;
  lastAlertTime = now;

  // Haptic feedback: vibrate on native (Android needs VIBRATE permission)
  if (Platform.OS !== 'web') {
    try {
      Vibration.vibrate(ALERT_VIBRATION_PATTERN);
    } catch {
      // Silent fail if vibration unavailable
    }
  }

  try {
    SoundPlayer.playUrl(FALLBACK_ALERT_URL);
  } catch {
    try {
      SoundPlayer.playSoundFile('alert', 'mp3');
    } catch {
      // Silent fail if no sound available
    }
  }
}
